import { createApp } from 'vue';
import MapDrive from '@/pages/MapDriveReport.vue';

/**
 * 測定結果管理ページ用のスクリプト
 */
 if (is_route('event_video.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        event_video_event_set();
        event_video_control();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.event_video_event_set = function() {
    /*---- 検索条件変更時 ----*/
    // 会社変更時
    $(document).on('change', '#search-form-company_id', function () {
        _select.set_select(this, 'select.search-form-section-select', {'company_id': $(this).val()});
    });

    // 日時（開始）変更時
    $(document).on('change', '#search-form-start_time', function (e) {
        e.preventDefault();
        e.stopPropagation();
        changeStartedAt(this, '#search-form-end_time');
    });

    // 日時（終了）変更時
    $(document).on('change', '#search-form-end_time', function (e) {
        e.preventDefault();
        e.stopPropagation();
        changeEndedAt(this, '#search-form-start_time');
    });

    // 単位変更時
    $(document).on('change', 'input[name="type"]', function() {
        let inputMode = $('input[name="mode"]');
        if ($(this).val() === 'video') {
            $('#mode-block').removeClass('d-none').addClass('d-flex');
            if (inputMode.val() === '') {
                inputMode.val('list'); // 初期値
                $('a[data-name="mode"]').removeClass('active');
                $('a[data-name="mode"][data-value="list"]').addClass('active');
            }
        }else {
            $('#mode-block').removeClass('d-flex').addClass('d-none');
            inputMode.val('');
        }
    });

    // 全て選択用のチェックボックス
    $(document).on('change', '#all-select-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).prop('checked')) {
            //個別のイベント種別チェックボックスからチェックを外して、非選択状態の状態にする
            $('.event_type-check').prop('checked', false);
        }else {
            // 自分自身のチェックは外させない(全て選択のチェックが外れるのは個別チェックボックスの押下時のみ)
            $(this).prop('checked', true);
        }
    });

    // イベント種別の個別チェックボックス
    $(document).on('change', '.event_type-check', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // 全て選択チェックボックスが選択状態だったら、非選択状態にする
        if ($('#all-select-btn').prop('checked')) {
            $('#all-select-btn').prop('checked', false);
        }
        if($('.event_type-check:checked').length <= 0) {
            //全てのチェックボックスのチェックが外れていたら全て選択を選択状態にする
            $('#all-select-btn').prop('checked', true);
        }
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        let datas = $('#search-form').serializeArray();
        datas.push({'name': 'id', 'value': $(this).data('id')});
        datas.push({'name': 'time', 'value': $(this).data('time')});
        _modal.create_with_data(this, 'setting-modal', datas, false, function() {
            /*
            if ($('#event_video_details').hasClass('only-locations')) {
                $('#drive_details_modal .modal-event_video').css('width', '650px');
            } else {
                $('#drive_details_modal .modal-event_video').css('width', '68%');
            }
                */
               /*
            setTimeout(function(){
                createMap();
            },1000);
            */
            setTimeout(function () {
                const zMapMain = $('#event_video_details').find('.video-map');
                const app = createApp(MapDrive, {
                    lat: zMapMain.data('zip_lat'),
                    lon: zMapMain.data('zip_lon'),
                    vehicleData: zMapMain.data('eventvideo_map_data'),
                });
                app.mount(zMapMain.get(0));
            }, 1000);
        });
    });

    // 動画表示へ切り替え
    $(document).on('click', '#show-video-btn', function () {
         $("#event-video-map-box").hide();
         $("#video-contents-box").show();
         $(this).addClass('active');
        $('#show-map-btn').removeClass('active');
     });

    // 地図表示へ切り替え
    $(document).on('click', '#show-map-btn', function () {
        $("#video-contents-box").hide();
        $("#event-video-map-box").show();
        $(this).addClass('active');
        $('#show-video-btn').removeClass('active');
        $('#video-map div:first').css('width', $('#event_video_details').find('.video-map').width() + 'px');
    });

    function changeStartedAt(elm, target)
    {
        let last_day = null;
        let selected_date = $(elm).val();
        let set_end = $(target).val();
        if(set_end != ''){
            selected_date = new Date(selected_date);
            let chk_date_over = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
            let chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate());
            set_end = new Date(set_end);
            let yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate());
            if(chk_date_over.getTime() < yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $(target).val(last_day);
            }else if(chk_date.getTime() > yyyymmdd.getTime()){
                last_day = chk_date.getFullYear()+'/'+
                        ( "0"+( chk_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+chk_date.getDate() ).slice(-2);
                $(target).val(last_day);
            }
        }
    }

    function changeEndedAt(elm, target)
    {
        let last_day = null;
        let selected_date = $(elm).val();
        let set_start = $(target).val();
        if(set_start != ''){
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            let yyyymmdd = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate() + 31);
            let yyyymmdd_2 = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate());
            if(selected_date.getTime() > yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() - 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $(target).val(last_day);
            }else if(selected_date.getTime() < yyyymmdd_2.getTime()){
                yyyymmdd_2 = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() - 31);
                last_day = yyyymmdd_2.getFullYear()+'/'+
                        ( "0"+( yyyymmdd_2.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd_2.getDate() ).slice(-2);
                $(target).val(last_day);
            }
        }
    }

    // モーダル上に地図を生成
    function createMap() {

        let vehicleData = $('#event_video_details').find('.video-map').data('eventvideo_map_data');
        let zMapMain = $('#event_video_details').find('.video-map');
        let polylineLociLatlon = [];
        let options = {
            addressOfMarker: false,
            zoom: 11,
        };
        if (zMapMain.length > 0) {
            zMapMain.empty();
            //地図を作成
            zMapMain.attr('width', zMapMain.width() + 'px');
            zMapMain.attr('height', zMapMain.height() + 'px');
            if (zMapMain.data('zip_lat') !== '' || zMapMain.data('zip_lon') !== '') {
                options.lat = zMapMain.data('zip_lat');
                options.lon = zMapMain.data('zip_lon');
            }
            _zdcMap.Map.init(zMapMain, options, false);
            if(vehicleData.length > 0) {
                //地図上に経路の線を引く
                $.each(vehicleData, function(i, item){
                    polylineLociLatlon.push(new ZDC.LatLon(item.latitude, item.longitude));
                });
                polylineLoci = new ZDC.Polyline(
                    polylineLociLatlon,
                    {
                        strokeColor: '#669DF6',
                        strokeWeight: 3,
                    }
                );
                _zdcMap._zMap.addWidget(polylineLoci);

                //地図上にイベントを示す円を描く
                $.each(vehicleData, function(i, item){
                    if(item.back > 0 || item.brake > 0 || item.blinker > 0) {
                        eventOval = new ZDC.Oval(
                            {
                                latlon: new ZDC.LatLon(item.latitude, item.longitude),
                                x:      5,
                                y:      5,
                            },
                            {
                                strokeColor: '#000000',
                                strokeWeight: 2,
                                fillColor:'#FF0000',
                            }
                        );
                        _zdcMap._zMap.addWidget(eventOval);
                    }
                });

                //地図上に開始地点を示すマーカーを描く
                startMarker = new ZDC.Marker(
                    new ZDC.LatLon(vehicleData[0].latitude, vehicleData[0].longitude),
                    {
                        /* マーカのサイズに合わせて位置を調整する */
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../images/icon_event.png'
                            }
                        }
                    }
                );
                _zdcMap._zMap.addWidget(startMarker);

                //地図上に終了地点を示すマーカーを描く
                endMarker = new ZDC.Marker(
                    new ZDC.LatLon(vehicleData.slice(-1)[0].latitude, vehicleData.slice(-1)[0].longitude),
                    {
                        /* マーカのサイズに合わせて位置を調整する */
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../images/icon_event.png'
                            }
                        }
                    }
                );
                _zdcMap._zMap.addWidget(endMarker);
            }
        }

        let yuricargoVehicleData = $('#yuricargo_details').find('.yuricargo-map').data('yuricargo_map_data');
        let yuricargozMapMain = $('#yuricargo_details').find('.yuricargo-map');
        let yuricargoPolylineLociLatlon = [];

        if (yuricargozMapMain.length > 0) {
            yuricargozMapMain.empty();
            //地図を作成
            yuricargozMapMain.attr('width', yuricargozMapMain.width() + 'px');
            yuricargozMapMain.attr('height', yuricargozMapMain.height() + 'px');
            if (yuricargozMapMain.data('zip_lat') !== '' || yuricargozMapMain.data('zip_lon') !== '') {
                options.lat = yuricargozMapMain.data('zip_lat');
                options.lon = yuricargozMapMain.data('zip_lon');
            }
            _zdcMap.Map.init(yuricargozMapMain, options, false);
            if(yuricargoVehicleData.length > 0) {
                //地図上に経路の線を引く
                $.each(yuricargoVehicleData, function(i, item){
                    yuricargoPolylineLociLatlon.push(new ZDC.LatLon(item.latitude, item.longitude));
                });
                polylineLoci = new ZDC.Polyline(
                    yuricargoPolylineLociLatlon,
                    {
                        strokeColor: '#669DF6',
                        strokeWeight: 3,

                    }
                );
                _zdcMap._zMap.addWidget(polylineLoci);

                //地図上にイベントを示す円を描く
                $.each(yuricargoVehicleData, function(i, item){
                    if(item.back > 0 || item.brake > 0 || item.blinker > 0) {
                        eventOval = new ZDC.Oval(
                            {
                                latlon: new ZDC.LatLon(item.latitude, item.longitude),
                                x:      5,
                                y:      5,
                            },
                            {
                                strokeColor: '#000000',
                                strokeWeight: 2,
                                fillColor:'#FF0000',
                            }
                        );
                        _zdcMap._zMap.addWidget(eventOval);
                    }
                });

                //地図上に開始地点を示すマーカーを描く
                startMarker = new ZDC.Marker(
                    new ZDC.LatLon(yuricargoVehicleData[0].latitude, yuricargoVehicleData[0].longitude),
                    {
                        /* マーカのサイズに合わせて位置を調整する */
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../images/icon_event.png'
                            }
                        }
                    }
                );
                _zdcMap._zMap.addWidget(startMarker);

                //地図上に終了地点を示すマーカーを描く
                endMarker = new ZDC.Marker(
                    new ZDC.LatLon(yuricargoVehicleData.slice(-1)[0].latitude, yuricargoVehicleData.slice(-1)[0].longitude),
                    {
                        /* マーカのサイズに合わせて位置を調整する */
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../images/icon_event.png'
                            }
                        }
                    }
                );
                _zdcMap._zMap.addWidget(endMarker);
            }
        }
    }

    // タイマーの受取変数
    var timer = 0;
    // ウィンドウがリサイズされたとき
    window.addEventListener("resize", function(){
        // リサイズしているときは、タイマーをリセットする
        clearTimeout(timer);

        // 指定時間後、一度だけ処理を実行

        timer = setTimeout(function(){
            $('#video-map div:first').css('width', $('#event_video_details').find('.video-map').width() + 'px');
        }, 400);

        timer = setTimeout(function(){
            $('#yuricargo-map div:first').css('width', $('#yuricargo_details').find('.yuricargo-map').width() + 'px');
        }, 400);
    });

    $(document).on('click', '#event_video_details-tab' , function () {
        $('#video-map div:first').css('width', $('#event_video_details').find('.video-map').width() + 'px');
    });

    $(document).on('click', '#yuricargo_details-tab' , function () {
        $('#yuricargo-map div:first').css('width', $('#yuricargo_details').find('.yuricargo-map').width() + 'px');
    });

}

/*---- イベント動画 ----*/

window.event_video_control = function() {
    // 動画表示時
    // リア動画URL保持
    let uri_rear = '';
    let nowTime;
    let isUserSeeking = false;
    let wasPlayingBeforeSeek = false;

    // 対応する動画が無い行を選んだとき、直前の動画を流したままにすると
    // その行の動画に見えてしまうため、再生を止めて案内へ切り替える
    function showNoViolationVideo() {
        $('video[id^="drive_details_modal-player-"]').each(function () {
            this.pause();
        });
        $('#drive_details_modal-play_stop').find('i').removeClass('fa-stop').addClass('fa-play');
        $('#video-contents-box').find('.video_viewport, .video_controls').addClass('d-none');
        $('#no-violation-video-box').removeClass('d-none');
    }

    $(document).on('click', '.drive-details-row', function () {
        let videos = $(this).data('videos');
        let camera_count = $(this).data('camera_count');

        $('.drive-details-row').removeClass('select_table_row');
        $(this).addClass('select_table_row');

        if (!videos) {
            showNoViolationVideo();
            return;
        }

        $('#no-violation-video-box').addClass('d-none');
        $('#video-contents-box').find('.video_viewport, .video_controls').removeClass('d-none');

        $('#drive_details_modal-play_stop').trigger('click');
        $('#drive_details_modal-time-slider').val(0);

        if(videos[0]['camera_type'] == 'compiled-import') {
            $('#drive_details_modal-player-front source').attr('src', videos[0].uri);
            $('#drive_details_modal-player-rear source').attr('src', '');
            $('#video_box').addClass('multiple_video_box');

            var nc = $('input[name="cameras"]:checked').val();
            if(nc !='999') {
                $('#drive_details_modal-player-front').addClass('camera'+nc);
            }
            $('#drive_details_modal-player-front').removeClass('d-none');
            $('#drive_details_modal-player-rear').addClass('d-none');

            if(camera_count == 1) {
                $('#drive_details_modal-2c').parent().addClass('d-none');
                $('#drive_details_modal-3c').parent().addClass('d-none');
            } else if(camera_count == 2) {
                $('#drive_details_modal-2c').parent().removeClass('d-none');
                $('#drive_details_modal-3c').parent().addClass('d-none');
            } else {
                $('#drive_details_modal-2c').parent().removeClass('d-none');
                $('#drive_details_modal-3c').parent().removeClass('d-none');
            }
            $('#drive_details_modal-all').parent().removeClass('d-none');
            $('.multiple_video_box').removeClass(function(index, className) {
                return (className.match(/\bcamera_count_\S+/g) || []).join(' ');
            })
            $('.multiple_video_box').addClass('camera_count_'+camera_count);

            let front = $('video[id="drive_details_modal-player-front"]')[0];
            let rear = $('video[id="drive_details_modal-player-rear"]')[0];

            front.currentTime = 0;
            rear.currentTime = 0;

            front.onloadedmetadata = function() {
                $('#drive_details_modal-time-slider').val(0);
            };
            front.load();
            rear.load();

            $('#drive_details_modal-play_stop').trigger('click');

        } else {
            $('#video_box').removeClass('multiple_video_box');

            // カメラ数の切り替え
            var nc = $('input[name="cameras"]:checked').val();
            // alert("Selected value: " + nc);
            if(nc != 999) {
                $('#drive_details_modal-player-front').removeClass('camera'+nc);
            }

            if(nc != 2) {
                $('#drive_details_modal-1c').parent().addClass('active');
                $('#drive_details_modal-player-front').removeClass('d-none');
                $('#drive_details_modal-player-rear').addClass('d-none');
            } else {
                $('#drive_details_modal-player-front').addClass('d-none');
                $('#drive_details_modal-player-rear').removeClass('d-none');
            }

            $('#drive_details_modal-3c').parent().removeClass('active').addClass('d-none');
            $('#drive_details_modal-all').parent().removeClass('active').addClass('d-none');

            // 画像が必ずペア（フロント側とリア側）
            $('video[id^="drive_details_modal-player-"]').each(function() {
                // 動画が必ず２つあるのため、１つずつセットする
                let id = $(this).attr('id');
                let cameraType = id.replace('drive_details_modal-player-', '');

                let video = videos.find(video => video.camera_type === cameraType);
                if (video) {

                    if (cameraType == 'rear') {
                        uri_rear = video.uri;

                        // 1カメラの場合、リア側セットしない
                        if (nc == 1) {
                            return false;
                        }
                    }

                    $(this).find('source').attr('src', video.uri);

                    let vdo = $(this)[0];
                    vdo.load();
                }
            });

            let front = $('video[id="drive_details_modal-player-front"]')[0];
            let rear = $('video[id="drive_details_modal-player-rear"]')[0];

            front.currentTime = 0;
            rear.currentTime = 0;

            // ２つの動画の長さが同じのが前提
            front.onloadedmetadata = function() {
                $('#drive_details_modal-time-slider').val(0);
            };
            front.load();
            rear.load();

            $('#drive_details_modal-play_stop').trigger('click');
        }
    });


    // カメラの切り替え
    $(document).on('change', 'input[name="cameras"]', function () {
        let play_stop_icon = $('#drive_details_modal-play_stop').find('i');
        let play = play_stop_icon.hasClass('fa-play');
        if (!play) {
            play_stop_icon.removeClass('fa-stop').addClass('fa-play');
        }
        if ($(this).is(':checked')) {
            var nc = $(this).val();

            let front = $('#drive_details_modal-player-front');
            if($('.multiple_video_box').length) {
                var nc = $(this).val();
                front.removeClass('camera1');
                front.removeClass('camera2');
                front.removeClass('camera3');
                if(nc != 999) {
                    front.addClass('camera'+nc);
                }

                front[0].pause();
            }else{
                let rear = $('#drive_details_modal-player-rear');

                // 2カメラ
                if (nc == 2) {
                    front.addClass('d-none');
                    rear.removeClass('d-none');

                    if (!rear.find('source').attr('src')) {
                        rear.find('source').attr('src', uri_rear);
                        rear[0].load();
                    }
                    // カメラ２をカメラ１の状態で設定
                    rear[0].volume = front[0].volume;
                    rear[0].currentTime = front[0].currentTime;
                    rear[0].pause();

                    // カメラ1を停止
                    front[0].pause();
                    // front.find('source').attr('src', null);
                }

                // 1カメラ
                if (nc == 1) {
                    front.removeClass('d-none');
                    rear.addClass('d-none');

                    // カメラ１をカメラ２の状態で設定
                    front[0].volume = rear[0].volume;
                    front[0].currentTime = rear[0].currentTime;

                    // カメラ２を停止
                    rear[0].pause();
                    // rear.find('source').attr('src', null);
                }
                // 再生速度を設定
                changeSpeed();
            }

        }
    });

    // イベント動画を閉じる
    $(document).on('click', '#drive_details_modal .close', function () {

        $('video[id^="drive_details_modal-player-"]').each(function() {
            let vdo = $(this)[0];

            vdo.pause();
        });

    });

    // 再生・停止切り替え
    $(document).on('click', '#drive_details_modal-play_stop', function () {
        let icon = $(this).find('i');
        let play = icon.hasClass('fa-play');

        let src = '';
        let nc = $('input[name="cameras"]:checked').val();
        $('video[id^="drive_details_modal-player-"]').each(function() {
            if (!src) {
                src = $(this).find('source').attr('src');
            }
        });
        if (!src) {
            $('#drive_details_modal-video-row-0').trigger('click');
        }

        let player;
        if($('.multiple_video_box').length) {
            player = $('#drive_details_modal-player-front') ;
        } else {
            player = nc == 1 ? $('#drive_details_modal-player-front') : $('#drive_details_modal-player-rear');
        }

        let vdo = $(player)[0];
        if (play) {
            changeSpeed();
            vdo.play();
        } else {
            vdo.pause();
        }

        if (play) {
            icon.removeClass('fa-play').addClass('fa-stop');
        } else {
            icon.removeClass('fa-stop').addClass('fa-play');
        }
    });

    //モーダルが生成されてから行わせる動作
    $(document).on('shown.bs.modal','#drive_details_modal', function () {
        //動画の更新
        $('video[id^="drive_details_modal-player-"]').on('timeupdate',function() {
            if (isUserSeeking) {
                 return;
            }
            // 動画の現在時間が更新されたらスライダーを更新
            nowTime = Math.floor(100 * ($(this)[0].currentTime / $(this)[0].duration));
            $('#drive_details_modal-time-slider').val(nowTime);
        });
        $('#drive_details_modal-time-slider').val(0);
    });

    $(document).on('mousedown touchstart', '#drive_details_modal-time-slider', function () {
        isUserSeeking = true;
        $('#drive_details_modal-play_stop').find('i').removeClass('fa-stop').addClass('fa-play');
        let nc = $('input[name="cameras"]:checked').val();

        let player;
        if($('.multiple_video_box').length) {
            player = $('#drive_details_modal-player-front') ;
        } else {
            player = nc == 1 ? $('#drive_details_modal-player-front') : $('#drive_details_modal-player-rear');
        }

        wasPlayingBeforeSeek = !player[0].paused;
        player[0].pause();
    });

    $(document).on('mouseup touchend', '#drive_details_modal-time-slider', function () {
        isUserSeeking = false;
        // 止めていた動画をシークだけで再生させない
        if (!wasPlayingBeforeSeek) {
            return;
        }
        $('#drive_details_modal-play_stop').find('i').removeClass('fa-play').addClass('fa-stop');
        let nc = $('input[name="cameras"]:checked').val();

        let player;
        if($('.multiple_video_box').length) {
            player = $('#drive_details_modal-player-front') ;
        } else {
            player = nc == 1 ? $('#drive_details_modal-player-front') : $('#drive_details_modal-player-rear');
        }

        player[0].play();
    });

     $(document).on('input', '#drive_details_modal-time-slider',  function () {
        let nc = $('input[name="cameras"]:checked').val();

        let player;
        if($('.multiple_video_box').length) {
            player = $('#drive_details_modal-player-front') ;
        } else {
            player = nc == 1 ? $('#drive_details_modal-player-front') : $('#drive_details_modal-player-rear');
        }

        let video  = player[0];
        let percent = $(this).val();
        let seekTime = video.duration * (percent / 100);
        video.currentTime = seekTime;
    });

    // 時間変更時
    $(document).on('input', '#drive_details_modal-time-slider', function () {
        let currentTime = $(this).val();

        $('video[id^="drive_details_modal-player-"]').each(function() {
            let vdo = $(this)[0];
            vdo.currentTime = currentTime;
        });
    });

    // 音量切り替え
    $(document).on('click', '#drive_details_modal-volume_switch', function () {
        let btn = $(this).find('i');

        $('video[id^="drive_details_modal-player-"]').each(function() {
            let vdo = $(this)[0];

            if (vdo.muted) {
                vdo.muted = false;
                // Update volume icon based on current volume
                let volume = vdo.volume;
                if (volume == 0) {
                    btn.removeClass().addClass('fa fa-volume-off');
                } else if (volume < 0.5) {
                    btn.removeClass().addClass('fa fa-volume-down');
                } else {
                    btn.removeClass().addClass('fa fa-volume-up');
                }
            } else {
                vdo.muted = true;
                btn.removeClass().addClass('fa fa-volume-mute');
            }
        });

    });

    // 音量変更時
    $(document).on('input', '#drive_details_modal-volume-slider', function () {

        let volume = $(this).val();

        $('video[id^="drive_details_modal-player-"]').each(function() {
            let vdo = $(this)[0];

            if (vdo.muted) {
                vdo.muted = false;
            }
            vdo.volume = volume;
        });

        // アイコン変更
        let icon = $('#drive_details_modal-volume_switch').find('i');

        if (volume == 0) {
            icon.removeClass().addClass('fa fa-volume-off');
        } else if (volume < 0.5) {
            icon.removeClass().addClass('fa fa-volume-down');
        } else {
            icon.removeClass().addClass('fa fa-volume-up');
        }

    });

    // 速度変更ボタンクリック時
    $(document).on('click', '[id^="drive_details_modal-speed-"]', function () {
        // 速度取得
        let speed = $(this).attr('id').split('-').pop();
        changeSpeed(speed);
    });

    // 速度変更
    function changeSpeed(speed = null){
        if (speed == null) {
            speed = $('.speed-btn.active').find('[id^="drive_details_modal-speed-"]').attr('id').split('-').pop();
        }
        if (speed === "") {
            speed = 0.1; // Default for コマ送り
        } else {
            speed = parseFloat(speed);
        }

        $('video[id^="drive_details_modal-player-"]').each(function() {
            let vdo = $(this)[0];

            vdo.playbackRate = speed;
        });
    }
}

